import { withPlaceholder } from '../../Placeholders';
import { SingleRowPlaceholder } from '../../Placeholders/Templates';
import Button from '../Button';

export default withPlaceholder({
    customPlaceholder: SingleRowPlaceholder
})(Button);
